export default "__VITE_ASSET__C7YKu$WV__"